import React from 'react';
import * as Icons from 'lucide-react';
import { subjects } from '../mock';

export default function Subjects() {
  return (
    <section id="subjects" className="py-16 lg:py-24 bg-[#2C3E50] text-[#FFF8EC] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: 'radial-gradient(circle, #FFF8EC 1px, transparent 1px)',
        backgroundSize: '28px 28px'
      }} />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-[#F4B93E] uppercase tracking-[0.25em] font-black text-xs">Subjects we teach</span>
            <h2 className="mt-3 text-3xl lg:text-5xl font-black leading-[1.05]">
              A tutor for <span className="text-[#F4B93E]">every subject</span>
              <br className="hidden sm:block"/> your child needs.
            </h2>
          </div>
          <p className="lg:max-w-md text-[#FFF8EC]/70 text-lg">
            From weekly homework help to full syllabus coverage, our tutors specialise in what they teach — not everything under the sun.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {subjects.map((s) => {
            const Ic = Icons[s.icon] || Icons.BookOpen;
            const light = s.textLight;
            return (
              <div key={s.name} className={`group ${s.color} ${light ? 'text-[#FFF8EC]' : 'text-[#2C3E50]'} rounded-2xl border-2 border-[#FFF8EC] p-5 hover:-translate-y-1 cursor-pointer`}>
                <div className={`w-12 h-12 rounded-xl ${light ? 'bg-[#F4B93E]' : 'bg-[#FFF8EC]'} border-2 border-[#2C3E50] flex items-center justify-center mb-4 group-hover:rotate-[-6deg]`}>
                  <Ic size={22} className="text-[#2C3E50]" strokeWidth={2.4} />
                </div>
                <h3 className="text-xl font-black">{s.name}</h3>
                <p className={`mt-2 text-sm font-semibold ${light ? 'text-[#FFF8EC]/85' : 'text-[#2C3E50]/85'} leading-relaxed`}>{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
